// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Pi-TyRUyaCapuT_UY45fq","title":"_2fKtsgTCp1U4K4vntYTNP0","description":"_3r96vwl7rcyHJ39gjexsdX"};